
import React from 'react';
import { connect } from "react-redux";
import Logo from './../../../images/white_logo.png'
import { BiLogOutCircle } from 'react-icons/bi';
import { FaUserCircle } from 'react-icons/fa';
import logout from './../../../Global/logout'
import ReactNotification from 'react-notifications-component'
import 'react-notifications-component/dist/theme.css'
import { TiThMenuOutline } from 'react-icons/ti';
import { IconContext } from 'react-icons/lib';
import { Col, Row } from 'react-bootstrap';

export class TopBar extends React.Component{

    state={
        hideNav: false
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }
    
    resize() {
        this.setState({hideNav: window.innerWidth <= 768});
    }
    
    componentWillUnmount() {
        window.removeEventListener("resize", this.resize.bind(this));
    }

    handleToggleSidebar = async (e) => {
        await this.props.mapState("USER_MAP_SETTINGS", {column: "asideToggled", value: !this.props.user.user_web_properties.settings.asideToggled});
    }

    

    render(){
        return (
            <Row className="topBar p-0 m-0">
                <ReactNotification />

                {this.state.hideNav &&
                    <div 
                        className="btn-toggle topbar-sidebar"
                        onClick={() => this.handleToggleSidebar(true)}
                    >
                        <IconContext.Provider >
                            <TiThMenuOutline size={24}/>
                        </IconContext.Provider>
                    </div>
                }

                <Col>
                    <img src={Logo} alt="logo"/>
                </Col>
               
                
                <Col className="text-end d-contents">
                    <div className="top-name lh-sm" >
                        <span><strong>{this.props.user.first_name} {this.props.user.last_name}</strong></span>
                    </div>
                    <FaUserCircle size={40} className="m-10"/>
                    <BiLogOutCircle 
                        size={40} 
                        onClick={logout}
                        className="hoverPointer hoverColorRed topIcon top-name me-2"
                    />
                    
                </Col>
                
                
                
            </Row>

        );
    };
}


const mapStateToProps = state => {
  return {
      user: state.user
  };
};

const mapDispatchToProps = dispatch => {
  return {
    mapState: (type, data) => dispatch({ type: type, data: data})
  };
};



export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TopBar);

